import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, VALID_ADMIN_ROLES } from '../const.config';

// Apps module configurations
export const LISTING_COLUMNS = [
  {
    id: 'name',
    label: 'Name',
    width: '13%',
    align: 'left',
    dataKey: 'name',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'version',
    label: 'APP Version',
    width: '10%',
    align: 'center',
    dataKey: 'version',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'brdVersion',
    label: 'BRD Version',
    width: '10%',
    align: 'center',
    dataKey: 'brdVersion',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'brdApproved',
    label: 'BRD Approved',
    width: '10%',
    align: 'center',
    dataKey: 'brdApproved',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'forceUpgrade',
    label: 'Force Upgrade',
    width: '10%',
    align: 'center',
    dataKey: 'forceUpgrade',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'bundleId',
    label: 'Bundle ID',
    width: '10%',
    align: 'center',
    dataKey: 'bundleId',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'platform',
    label: 'Platform',
    width: '2%',
    align: 'left',
    dataKey: 'platform',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'submittedAt',
    label: 'Submitted Date',
    width: '15%',
    align: 'center',
    dataKey: 'submittedAt',
    sortable: true,
    type: CELL_DATA_TYPES.DATETIME,
  },
  {
    id: 'liveAt',
    label: 'Live Date',
    width: '15%',
    align: 'center',
    dataKey: 'liveAt',
    sortable: true,
    type: CELL_DATA_TYPES.DATETIME,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
    conditional: (val) => val.role !== VALID_ADMIN_ROLES.SUPER_ADMIN,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  }
];

export const VIEW_COLUMNS = [
  {
    id: 'name',
    label: 'Name',
    dataKey: 'name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'version',
    label: 'APP Version',
    dataKey: 'version',
    type: CELL_DATA_TYPES.TEXT,
  },
    {
    id: 'brdVersion',
    label: 'BRD Version',
    dataKey: 'brdVersion',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'brdApproved',
    label: 'BRD Approved',
    dataKey: 'brdApproved',
    type: CELL_DATA_TYPES.BRDAPPROVED,
  },
  {
    id: 'bundleId',
    label: 'Bundle ID',
    dataKey: 'bundleId',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'platform',
    label: 'Platform',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'submittedAt',
    label: 'Submitted Date',
    dataKey: 'submittedAt',
    type: CELL_DATA_TYPES.DATETIME,
  },
  {
    id: 'liveAt',
    label: 'Live Date',
    dataKey: 'liveAt',
    type: CELL_DATA_TYPES.DATETIME,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
